import { popupPane } from './popuppane';
import * as colorConvert from 'color-convert';
import * as gradientParser from 'gradient-parser';


type RGB = [number, number, number];
type RGBA = [number, number, number, number]

type ColorStop = {
  color: RGBA,
  position: {
    unit: string,
    value: number
  },
  $?: JQuery // Mark
  x?: number, // Used to make UI consistent when 
  y?: number,  // a color can have different HSV values
  huePos?: number // e.g. at hue point 0 / 360
};

function rgbaToHex(rgba: RGBA) {
  let hex = colorConvert.rgb.hex(<RGB>rgba.slice(0,3));
  if (rgba[3] < 1) {
    hex += ('0' + (rgba[3]*255).toString(16)).substr(-2);
  }
  return hex;
}

function hexToRgba(hex: string): RGBA {
  if (/^#[0-9a-fA-F]{6}$/.test(hex)) {
    return [...colorConvert.hex.rgb(hex), 1];
  }
  // Valid hex with alpha
  else if (/^#[0-9a-fA-F]{8}$/.test(hex)) {
    return [...colorConvert.hex.rgb(hex), parseInt('0x' + hex.substr(7, 2)) / 255 ]
  } else {
    return [0, 0, 0, 0];
  }
}

function isValidColor(string: string) {
  let style = new Option().style;
  // Check solid colors
  style.color = string;
  if (style.color.length > 0) {
    return true;
  }

  // Check gradients
  style.backgroundImage = string;
  return (style.backgroundImage.length > 0);
}


export class Colorpicker {

  constructor($input: JQuery) {
    let colorpicker = this;
    $input.each(function() {
      let $this = $(this);
      let $preview = $this.closest('.colorPreviewInputWrap');
      let $clickers = $preview.length > 0 ? $preview : $this;
      $clickers.on('click', function openPicker(e) {
        let $this = $(this);
        let $trigger = $this.is('.colorPreviewInputWrap') ? $this.find('input') : $this;
        let $container = $trigger.closest('.editor');
        if ($trigger.data('openPicker') || $(e.target).is('.reset')) {
          return;
        }
        $trigger.data('openPicker', true);
        let options = {
          $trigger: $trigger,
          $container: $container,
          gradient: $trigger.is('.gradient'),
          value: $trigger.val(),
          fallback: $trigger.attr('placeholder')
        };
  
        let communicator = function(message) {
          if (typeof(message.value) !== 'undefined') {
            $trigger.val(message.value);
            $trigger.trigger('change');
          }
          if (message.kill) {
            $trigger.data('openPicker', false);
          }
        };
        colorpicker.popup(options, communicator);
      });
    });
  }

  popup(options, communicator?: (message: string) => void): void;
  popup(communicator?: (message: string) => void): void;
  popup() {
    let i=0;
    let options = typeof(arguments[i]) === 'object' ? arguments[i++] : {};
    let communicator = typeof(arguments[i]) === 'function' ? arguments[i++] : function() {};
    let $container = options.$container || $('body');
    let $trigger = options.$trigger || $container;
  
    // Render popup
    let markup = 
      '<div class="colorpicker uiPopup">' +
        '<div class="colorpickerGradientSelector">' +
          '<div class="colorpickerEnum">' +
            '<div class="colorpickerValue colorpickerValueSolid">Solid Color</div><div class="colorpickerValue colorpickerValueLinear">Linear Gradient</div><div class="colorpickerValue colorpickerValueRadial">Radial Gradient</div>' +
          '</div>' +
        '</div>' +
        '<div class="colorpickerGradientInputs">' +
          '<div class="colorpickerBigInput colorpickerInput colorpickerGradientOrientation">' +
            '<div class="colorpickerBigInputLabel">Gradient orientation</div><input type="text" data-max="360" class="colorpickerInputGradientOrientation" data-postfix="°"><div class="colorpickerInputSlider" data-float="false"><div class="colorpickerMark colorpickerInputGradientOrientationMark"></div></div>' +
          '</div>' +
          '<div class="colorpickerBigInput colorpickerInput">' +
            '<div class="colorpickerBigInputLabel">Gradient color stops</div><div class="colorpickerGradient transparentBg"><div class="colorpickerDynBg"></div></div>' +
          '</div>' +
        '</div>' +
        '<div class="colorpickerSpacer colorpickerGradientSpacer"></div>' +
        '<div class="colorpickerColor">' + 
          '<div class="colorpickerC">' +
            '<div class="colorpickerS">' +
              '<div class="colorpickerL">' +
                '<div class="colorpickerMark"></div>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="colorpickerSide">' +
            '<div class="colorpickerHue">' +
              '<div class="colorpickerMark"></div>' +
            '</div>' +
            '<div class="colorpickerOpacity transparentBg">' +
              '<div class="colorpickerDynBg"></div>' +
              '<div class="colorpickerMark"></div>' +
            '</div>' +
            '<div class="colorpickerInputs">' +
              '<div class="colorpickerInput"><div class="colorpickerInputLabel">R</div><input type="text" class="colorpickerInputRed"></div>' +
              '<div class="colorpickerInput"><div class="colorpickerInputLabel">G</div><input type="text" class="colorpickerInputGreen"></div>' +
              '<div class="colorpickerInput"><div class="colorpickerInputLabel">B</div><input type="text" class="colorpickerInputBlue"></div>' +
              '<div class="colorpickerInput"><div class="colorpickerInputLabel">A</div><input type="text" class="colorpickerInputOpacity"></div>' +
              '<div class="colorpickerInput"><div class="colorpickerInputLabel">Hex</div><input type="text" class="colorpickerInputHex"></div>' +
            '</div>' + 
          '</div>' +
        '</div>' + 
        '<div class="colorpickerClearFix"></div>' +
        '<div class="colorpickerSpacer"></div>' +
        '<button class="half cancel">Cancel</button>' +
        '<button class="half select right">Select</button>' +
      '</div>';
    let $picker = $(markup);
    if (options.gradient) {
      $picker.addClass('colorpickerWithGradient');
    }
  
    let $colorArea = $picker.find('.colorpickerC');
    let $hueArea = $picker.find('.colorpickerHue');
    let $opacityArea = $picker.find('.colorpickerOpacity');
    let $opacityAreaBg = $opacityArea.find('.colorpickerDynBg');
    let $gradient = $picker.find('.colorpickerGradient');
    let $gradientBg = $gradient.find('.colorpickerDynBg');
    let $colorMark = $colorArea.find('.colorpickerMark');
    let $hueMark = $hueArea.find('.colorpickerMark');
    let $opacityMark = $opacityArea.find('.colorpickerMark');
    let $gradientSelector = $picker.find('.colorpickerGradientSelector');
    let colorStops: ColorStop[] = [];
    let currentStop: ColorStop;
    let gradientType: string;
    let gradientOrientation;
    let $inputRed = $picker.find('.colorpickerInputRed');
    let $inputGreen = $picker.find('.colorpickerInputGreen');
    let $inputBlue = $picker.find('.colorpickerInputBlue');
    let $inputOpacity = $picker.find('.colorpickerInputOpacity');
    let $inputHex = $picker.find('.colorpickerInputHex');
    let $inputGradientOrientation = $picker.find('.colorpickerInputGradientOrientation');
    let $gradientOrientationMark = $picker.find('.colorpickerInputGradientOrientationMark');
    
    let placeholder: string = options.fallback;
    let originalValue: string = options.value;
    let value: string = originalValue || placeholder;// || 'transparent';

    if (!isValidColor(value)) {
      value = 'transparent';
    }

    // Parse currentColor format
    try {
      let gradient = gradientParser.parse(value)[0];
      gradientType = gradient.type;
      if (gradientType === 'linear-gradient' || gradientType === 'radial-gradient') {
        if (gradientType === 'linear-gradient') {
          if (!gradient.orientation) {
            gradientOrientation = 90;
          }
          else if (Array.isArray(gradient.orientation)) {
            // Not implemented
          }
          else if (gradient.orientation.type === 'directional') {
            if (gradient.orientation.value === 'right') gradientOrientation = 90;
            else if (gradient.orientation.value === 'left') gradientOrientation = 270;
            else if (gradient.orientation.value === 'top') gradientOrientation = 0;
            else if (gradient.orientation.value === 'bottom') gradientOrientation = 180;
          }
          else if (gradient.orientation && gradient.orientation.type === 'angular') {
            gradientOrientation = gradient.orientation.value; // + 'deg';
          }
        } else if (gradientType === 'radial-gradient') {
          if (Array.isArray(gradient.orientation)) {
          }
          else if (gradient.orientation) {
            gradientOrientation = gradient.orientation.value;
          } else {
            gradientOrientation = 'circle';
          }
        }
        for (let i=0; i<gradient.colorStops.length; i++) {
          let stop = gradient.colorStops[i];
          let color: RGBA;
          if (stop.type === 'rgb') {
            color = [parseInt(stop.value[0], 10), parseInt(stop.value[1], 10), parseInt(stop.value[2], 10), 1];
          } else if (stop.type === 'rgba') {
            color = [parseInt(stop.value[0], 10), parseInt(stop.value[1], 10), parseInt(stop.value[2], 10), parseInt(stop.value[3], 10)];
          } else if (stop.type === 'hex') {
            color = [...colorConvert.hex.rgb(stop.value), 1];
          } else if (stop.type === 'literal') {
            color = [...colorConvert.keyword.rgb(<any>stop.value), 1];
            return;
          }
          addGradientStop({
            color: color,
            position: {
              unit: (<any>stop).length ? (<any>stop).length.type : '%',
              value: (<any>stop).length ? (<any>stop).length.value : 100
            }
          });
        }
      }
    } catch (e) {
      gradientType = 'solid';
      gradientOrientation = '90';

      let color: RGBA;
      if (/^#[0-9a-fA-F]{6}/.test(value)) {
        color = hexToRgba(value);
      }
      else if (/^rgb/.test(value)) {
        let rgbArray = value.match(/[\.\d]+/g).map(function (a) {
			    return +a
		    });
        if (rgbArray.length === 4) color = <RGBA>rgbArray;
        else if (rgbArray.length === 3) color = <RGBA>[...rgbArray, 1];
        else color = [0, 0, 0, 0];
      }
      else if (value === 'transparent') {
        color = [0, 0, 0, 0];
      }
      else {
        color = [...colorConvert.keyword.rgb(<any>value), 1];
      }
    
      addGradientStop({
        color: color,
        position: {
          unit: '%',
          value: 0
        }
      });
      // We always want two colors
      addGradientStop({
        color: color,
        position: {
          unit: '%',
          value: 100
        }
      });
    }
  
    updateUI(false);
    popupPane($picker, $container, $trigger);
  
    function addGradientStop(colorStop: ColorStop) {
      colorStop.$ = $('<div class="colorpickerMark"><div class="colorpickerMarkRemove"></div><div class="colorpickerMarkLine"></div></div>');
      colorStop.$.data('colorStop', colorStop);
      $gradient.append(colorStop.$);
      colorStops.push(colorStop);
      if (colorStops.length === 2) {
        if (!gradientType) {
          gradientType = 'linear-gradient';
        }
      }
      if (!currentStop) {
        setCurrentStop(colorStop);
      }
    }
  
    function removeGradientStop(colorStop: ColorStop) {
      if (colorStops.length <= 1) {
        return;
      }
      let index = colorStops.indexOf(colorStop);
      if (index >= 0) {
        colorStops.splice(index, 1);
      }
      if (colorStops.length === 1) {
        $gradient.removeClass('colorpickerGradientGradient');
      }
      colorStop.$.remove();
  
      // A gradient should always have two stops
      if (colorStops.length <= 1) {
        addGradientStop({
          color: colorStops[0].color,
          position: {
            unit: '%',
            value: colorStops[0].position.value > 50 ? 0 : 100
          }
        });
      }
  
      if (currentStop === colorStop) {
        setCurrentStop();
        updateUI();
      }
    }
  
    function orderGradientStops() {
      colorStops.sort(function(a, b) {
        let aPosition = a.position.value || 0;
        let bPosition = b.position.value || 0;
        return aPosition - bPosition;
      });
    }
  
    function setCurrentStop(newStop?: ColorStop) {
      if (currentStop) {
        currentStop.$.removeClass('colorpickerActive');
      }
      if (!newStop) {
        newStop = colorStops[0];
      }
      currentStop = newStop;
      currentStop.$.addClass('colorpickerActive');
    }
  
    function updateUI(updateValue?: boolean) {
      let realStringValue = '';
      let uiStringValue = '';
      let width = $colorArea.width();
      let height = $colorArea.height();
  
      // Generate css strings
      if (!gradientType || gradientType === 'solid') {
        realStringValue += 'rgba(' + colorStops[0].color.join(', ') + ')';
        uiStringValue += 'rgba(' + colorStops[0].color.join(', ') + ')';
      } else {
        if (gradientType === 'linear-gradient') {
          realStringValue += gradientType + '(';
          realStringValue += gradientOrientation + 'deg, ';
        } else if (gradientType === 'radial-gradient') {
          realStringValue += gradientType + '(';
          realStringValue += 'circle, ';
        }
        uiStringValue += 'linear-gradient(90deg, ';
        for (let i=0; i<colorStops.length; i++) {
          realStringValue += 'rgba(' + colorStops[i].color.join(', ') + ')';
          uiStringValue += 'rgba(' + colorStops[i].color.join(', ') + ')';
          realStringValue += ' ' + colorStops[i].position.value + colorStops[i].position.unit;
          uiStringValue += ' ' + colorStops[i].position.value + colorStops[i].position.unit;
          if (i < colorStops.length-1) {
            realStringValue += ', ';
            uiStringValue += ', ';
          }
        }
        realStringValue += ')';
        uiStringValue += ')';
      }
  
      // Set UI positions for gradients
      for (let i=0; i<colorStops.length; i++) {
        let rgb = colorStops[i].color.slice(0,3);
        colorStops[i].$.css('left', colorStops[i].position.value + colorStops[i].position.unit);
        colorStops[i].$.css({
          background: 'rgb(' + rgb.join(',') + ')'
        });
      }
  
      let rgba = currentStop.color;
      let rgb = <RGB>rgba.slice(0, 3);
      let alpha = rgba[3];
      let hsla = [...colorConvert.rgb.hsl(rgb), alpha];
      let hsba = [...colorConvert.rgb.hsv(rgb), alpha];// hsb / hsv
  
      // Set UI positions for hue
      if (typeof(currentStop.huePos) === 'undefined') {
        currentStop.huePos = (100-(hsba[0]/360*100));
      }
      $hueMark.css({
        left: currentStop.huePos + '%',
        background: 'rgb(' + rgb.join() + ')'
      });
  
      // Set UI positions for color
      if (typeof(currentStop.x) === 'undefined') {
        currentStop.x = hsba[1];
      }
      if (typeof(currentStop.y) === 'undefined') {
        currentStop.y = 100-hsba[2];
      }
      $colorMark.css({
        left: currentStop.x + '%',
        top: currentStop.y + '%',
        background: 'rgb(' + rgb.join() + ')'
      });
  
      // Set opacity gradient
      $opacityAreaBg.css({
        background: 'linear-gradient(90deg, rgba(' + rgb.join() + ',1), rgba(' + rgba[0] +',' + rgba[1] +',' + rgba[2] +',0)'
      });
      $opacityMark.css({
        left: (100-(rgba[3]*100)) + '%',
        background: 'rgb(' + rgb.join() + ')'
      });
  
      // Set color area color
      $colorArea.css('backgroundColor', 'hsl(' + hsla[0] + ',' + '100%,50%)');
  
      $gradientBg.css('background', uiStringValue);
  
      // Set active gradient-mode button
      let $activeGradient;
      if (gradientType === 'linear-gradient') {
        $activeGradient = $gradientSelector.find('.colorpickerValueLinear');
      } else if (gradientType === 'radial-gradient') {
        $activeGradient = $gradientSelector.find('.colorpickerValueRadial');
      } else {
        $activeGradient = $gradientSelector.find('.colorpickerValueSolid');
      }
      $activeGradient.addClass('_active');
      $gradientSelector.find('.colorpickerValue').not($activeGradient).removeClass('_active');
  
      // Set text-values (RGB, HSL)
      $inputRed.val(rgba[0]);
      $inputGreen.val(rgba[1]);
      $inputBlue.val(rgba[2]);
      $inputOpacity.val(Math.round(rgba[3]*255));
      let hex = rgbaToHex(currentStop.color);
      $inputHex.val(hex.toUpperCase());
  
      $inputGradientOrientation.val(gradientOrientation);
      $gradientOrientationMark.css({
          left: (gradientOrientation/360*100) + '%'
      });
  
      // Add class for gradient
      if (gradientType === 'linear-gradient') {
        $picker.addClass('colorpickerModeLinearGradient');			
        $picker.removeClass('colorpickerModeRadialGradient');
      } else if (gradientType === 'radial-gradient') {
        $picker.addClass('colorpickerModeRadialGradient');
        $picker.removeClass('colorpickerModeLinearGradient');
      } else {
        $picker.removeClass('colorpickerModeLinearGradient');
        $picker.removeClass('colorpickerModeRadialGradient');
      }
  
      if (updateValue !== false) {
        communicator({
          value: realStringValue
        });
      }
  
    }
  
    $picker.on('close', select);
    function removeColorpicker() {
      $picker.off('close', select);
      $picker.trigger('close');
      communicator({
        kill: true
      });
    };
    
    
    //
    function onTextInput(e) {
      // Select on enter-button
      if (e.keyCode == '13') {
        select();
      }
      // Cancel on esc
      if (e.keyCode == '27') {
        cancel();
      }
    };
    
    // Reset on "cancel" click
    function cancel(e?) {
      communicator({
        value: originalValue || ''
      });
      removeColorpicker();
    };
    $picker.one('click', '.cancel', cancel);
  
    // Set value on select
    function select() {
      removeColorpicker();
    };
    $picker.one('click', '.select', select);
    
    // Set 
    if (value === 'transparent') {
      $colorArea.one('mousedown', (e) => {
        currentStop.color[3] = 1;
      });
    }
    // Select color
    $colorArea.on('mousedown', function(e) {
      if (e.which !== 1) {
        return;
      }
      let width = $colorArea.width();
      let height = $colorArea.height();
      function getSL(e) {
        let colorAreaOffset = $colorArea.offset();
        let x = Math.min(width, Math.max(0, e.pageX-colorAreaOffset.left));
        let y = Math.min(height, Math.max(0, e.pageY-colorAreaOffset.top));
        let saturation = Math.min(1, Math.max(0, x/width)) * 100;
        let brightness = Math.min(1, Math.max(0.0000001, 1-y/height)) * 100;
        let hsl = colorConvert.rgb.hsv(<RGB>currentStop.color.slice(0,3));
        let alpha = currentStop.color[3];
        currentStop.color = [...colorConvert.hsv.rgb([hsl[0], saturation, brightness]), alpha];
        currentStop.x = saturation;
        currentStop.y = 100-brightness;
        updateUI();
        return false;
      };
      getSL(e);
      window.addEventListener('click', function captureClick(e) {
        e.stopPropagation();
        window.removeEventListener('click', captureClick, true);
      }, true);
      $(window).on('mousemove', getSL);
      $(window).one('mouseup', function(e) {
        $(window).off('mousemove', getSL);
      });
      $container.one('mouseenter', 'iframe', function checkLeave(e) {
        $(window).off('mousemove', getSL);
      });
      return false;
    });
    
    $hueArea.on('mousedown', function(e) {
      if (e.which !== 1) {
        return;
      }
      let width = $hueArea.width();
      function getHue(e) {
        let hueAreaOffset = $hueArea.offset();
        let hue = Math.min(0.9999999, Math.max(0, (1-((e.pageX-hueAreaOffset.left)/width))) ) * 360;
        let hsl = colorConvert.rgb.hsl(<RGB>currentStop.color.slice(0, 3));
        let alpha = currentStop.color[3];
        currentStop.color = [...colorConvert.hsl.rgb([hue, hsl[1], hsl[2]]), alpha];
        currentStop.huePos = 100 - (100 * hue / 360);
        updateUI();
        return false;
      };
      getHue(e);
      $(window).on('mousemove', getHue);
      $(window).one('mouseup', function() {
        $(window).off('mousemove', getHue);
      });
      $container.one('mouseenter', 'iframe', function checkLeave(e) {
        $(window).off('mousemove', getHue);
      });
      window.addEventListener('click', function captureClick(e) {
        e.stopPropagation();
        window.removeEventListener('click', captureClick, true);
      }, true);
      return false;
    });
  
    $picker.on('mousedown', '.colorpickerInputSlider', function(e) {
      if (e.which !== 1) {
        return;
      }
      let $slider = $(this);
      let $input = $slider.closest('.colorpickerInput').find('input');
      let float = $slider.data('float');
      let width = $slider.width();
      let min = $input.data('min');
      let max = $input.data('max');
      if (typeof(min) === 'undefined') {
        min = 0;
      }
      if (typeof(max) === 'undefined') {
        max = 1;
      }
      function getValue(e) {
        let sliderOffset = $slider.offset();
        let value = min + ((e.pageX-sliderOffset.left)/width) * (max-min);
        value = Math.min(max, Math.max(min, value)); // Avoid rounding errors etc, clamp
        if (!float) {
          value = Math.round(value);
        }
        $input.val(value).trigger('change');
        return value;
      }
      getValue(e);
      $(window).on('mousemove', getValue);
      $(window).one('mouseup', function() {
        $(window).off('mousemove', getValue);
      });
      $container.one('mouseenter', 'iframe', function checkLeave(e) {
        $(window).off('mousemove', getValue);
      });
      window.addEventListener('click', function captureClick(e) {
        e.stopPropagation();
        window.removeEventListener('click', captureClick, true);
      }, true);
      return false;
    });
  
    // Move gradient color stop
    $gradient.on('mousedown', '.colorpickerMark', function(e) {
      if (e.which !== 1) {
        return;
      }
      let $colorStop = $(this);
      let colorStop: ColorStop = $colorStop.data('colorStop');
      let width = $gradient.width();
      let $target = $(e.target);
      function setPosition(e) {
        let areaOffset = $gradient.offset();
        let xPc = Math.min(100, Math.max(0, (e.pageX-areaOffset.left)/width * 100));
        colorStop.position = {
          value: xPc,
          unit: '%'
        };
        orderGradientStops();
        updateUI();
        return false;
      }
      setCurrentStop(colorStop);
      $(window).on('mousemove', setPosition);
      $(window).one('mouseup', function(e) {
        if ($target.is('.colorpickerMarkRemove')) {
          removeGradientStop(colorStop);
        }
        updateUI();
        $(window).off('mousemove', setPosition);
      });
      $container.one('mouseenter', 'iframe', function checkLeave(e) {
        $(window).off('mousemove', setPosition);
      });
      window.addEventListener('click', function captureClick(e) {
        e.stopPropagation();
        window.removeEventListener('click', captureClick, true);
      }, true);
      return false;
    });
  
  
    // Add new gradient color stop
    $gradient.on('click', function(e) {
      if (e.which !== 1) {
        return;
      }
      if ($(e.target).parents().addBack().filter('.colorpickerMark').length > 0) {
        return false;
      }
  
      let areaOffset = $gradient.offset();
      let width = $gradient.width();
      let positionPc = Math.min(100, Math.max(0, (e.pageX-areaOffset.left)/width * 100));
      let previousStop: ColorStop;
      let nextStop: ColorStop;
      let newStop: ColorStop = {
        color: [0, 0, 0, 0],
        position: {
          unit: '%',
          value: positionPc
        }
      };
  
      // Assumes all position units are %
      // Find next/previous
      for (let i=0; i<colorStops.length; i++) {
        let colorStop = colorStops[i];
        if (colorStop.position.value > positionPc) { // Next
          if (!nextStop || (colorStop.position.value < nextStop.position.value)) {
            nextStop = colorStop;
          }
        } else {
          if (!previousStop || (colorStop.position.value > previousStop.position.value)) {
            previousStop = colorStop;
          }
        }
      }
  
      // If there aren't two points, it's a solid color
      if (!previousStop && nextStop) {
        newStop.color = <RGBA>nextStop.color.slice();
      } else if (!nextStop && previousStop) {
        newStop.color = <RGBA>previousStop.color.slice();
      } else if (nextStop && previousStop) {
        let fraction = 1 - ((nextStop.position.value - positionPc) / (nextStop.position.value - previousStop.position.value));
        let previousRgba = previousStop.color;
        let nextRgba = nextStop.color;
        newStop.color = [
          previousRgba[0] + (nextRgba[0] - previousRgba[0]) * fraction,
          previousRgba[1] + (nextRgba[1] - previousRgba[1]) * fraction,
          previousRgba[2] + (nextRgba[2] - previousRgba[2]) * fraction,
          previousRgba[3] + (nextRgba[3] - previousRgba[3]) * fraction
        ];
      } else {
        return;
      }
  
      addGradientStop(newStop);
      setCurrentStop(newStop);
      orderGradientStops();
      updateUI();
    });
  
    // Opacity slider
    $opacityArea.on('mousedown', function(e) {
      if (e.which !== 1) {
        return;
      }
      let width = $opacityArea.width();
      function setOpacity(e) {
        let areaOffset = $opacityArea.offset();
        let opacity = 1 - Math.min(1, Math.max(0, (e.pageX-areaOffset.left)/width));
        currentStop.color[3] = opacity;
        updateUI();
        return false;
      }
      setOpacity(e);
      $(window).on('mousemove', setOpacity);
      $(window).one('mouseup', function() {
        $(window).off('mousemove', setOpacity);
      });
      $container.one('mouseenter', 'iframe', function checkLeave(e) {
        $(window).off('mousemove', setOpacity);
      });
      return false;
    });
  
    $gradientSelector.on('click', '.colorpickerValue', function(e) {
      if (e.which !== 1) {
        return;
      }
      let $this = $(this);
      let type;
      if ($this.is('.colorpickerValueLinear')) {
        type = 'linear-gradient';
        gradientOrientation = $inputGradientOrientation.val();
        if (typeof(gradientOrientation) === 'undefined') {
          gradientOrientation = 90;
        }
      } else if ($this.is('.colorpickerValueRadial')) {
        type = 'radial-gradient';
      } else {
        type = 'solid';
      }
      gradientType = type;
      updateUI();
    });
  
    $picker.on('keyup change', '.colorpickerInput input', function(e) {
      let $this = $(this);
      let newValue = $this.val().toString();
      let rgba = currentStop.color;
  
      let currentValue;
      let currentInput: string;
  
      if ($this.is('.colorpickerInputRed')) {
        currentValue = rgba[0];
        currentInput = 'red';
      } else if ($this.is('.colorpickerInputGreen')) {
        currentValue = rgba[1];
        currentInput = 'green';
      } else if ($this.is('.colorpickerInputBlue')) {
        currentValue = rgba[2];
        currentInput = 'blue';
      } else if ($this.is('.colorpickerInputOpacity')) {
        currentValue = rgba[3];
        currentInput = 'opacity';
      } else if ($this.is('.colorpickerInputHex')) {
        currentValue = rgbaToHex(currentStop.color);
        currentInput = 'hex';
      } else if ($this.is('.colorpickerInputGradientOrientation')) {
        currentInput = 'gradientOrientation';
      }
  
      if (currentInput !== 'hex') {
        let parsedVal = parseInt(newValue, 10);

        if (e.which === 40) {
          parsedVal = parsedVal - 1;
          newValue = parsedVal.toString();
          $this.val(newValue);
          e.preventDefault();
        }
        else if (e.which === 38) {
          parsedVal = parsedVal + 1;
          newValue = parsedVal.toString();
          $this.val(newValue);
          e.preventDefault();
        }
  
        let max = $this.data('max') || 255;
        let min = $this.data('min') || 0;
        // Revert to previous if it's not a valid integer
        if (isNaN(parsedVal)) {
          $this.val(currentValue || 0);
          return;
        } else {
          parsedVal = Math.min(max, Math.max(min, parsedVal));
          if (currentInput === 'red') rgba[0] = parsedVal;
          else if (currentInput === 'green') rgba[1] = parsedVal;
          else if (currentInput === 'blue') rgba[2] = parsedVal;
          else if (currentInput === 'opacity') rgba[3] = (parsedVal/255);
          else if (currentInput === 'gradientOrientation') gradientOrientation = parsedVal;
          currentStop.color = rgba;
        }
      } else {
        // Valid hex code without alpha
        currentStop.color = hexToRgba(newValue);
        return;
      }
      updateUI();
    });
  
    $picker.on('selectstart', false);
    
    // Set initial value
    updateUI(false);
  
    return $picker;
  };
  
}